module.exports = __webpack_public_path__ + "Sailec-Regular.3f903c54f17ba8cf8d33.svg";


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/assets/fonts/Sailec-Regular/Sailec-Regular.svg
// module id = ../../../../../src/assets/fonts/Sailec-Regular/Sailec-Regular.svg
// module chunks = styles